import { commissionTiersById } from '@constants/commissionTiers';

export default function isDoNotUseCommissionTier(
  commissionTierId: string | number,
): boolean {
  if (!commissionTierId) {
    return true;
  }
  const _commissionTierId = typeof commissionTierId === 'string' ? parseInt(commissionTierId, 10) : commissionTierId;
  return _commissionTierId === commissionTiersById.DO_NOT_USE;
}
